import {
  PreviewMarkdown as DsPreviewMarkdown,
  PreviewMarkdownCodeElement,
  PreviewMarkdownProps,
  CodeElementProps,
  notify,
} from '@cast/design-system';

const PreviewMarkdownCode = (props: CodeElementProps) => (
  <PreviewMarkdownCodeElement
    {...props}
    onCopy={() => notify.success('Copied to clipboard')}
  />
);

export const PreviewMarkdown = (props: PreviewMarkdownProps) => {
  return (
    <DsPreviewMarkdown
      {...props}
      components={{
        code: PreviewMarkdownCode,
        ...props.components,
      }}
    />
  );
};
